(function (app, ng) {

    function upcomingEvents(_, $filter) {
        return function (eventList, val) {
            return Object.values(_
                .chain(eventList)
                .filter(function (event) {
                    var eventStatus = $filter('dateStatus')(event.EventDate);
                    return eventStatus === 'Upcoming';
                })
                .sortBy(['EventDate'])
                .groupBy('EventDate')
                .value()
            )[0];
        };
    }

    upcomingEvents.$inject = ["_", "$filter"];
    app.filter("upcomingEvents", upcomingEvents);

})(window.app, window.angular); //jshint ignore:line